(function () {
  /* ---------------------------------------------------------------
     ABA VAULT CLOSE TIME  <-- edit this one line to change the deadline

     Format: ISO 8601 with an explicit timezone.
       'Z' = GMT/UTC.
     NOTE: the UK runs on BST (UTC+1) from late March to late October,
     so 12:00Z shows as 13:00 UK local time during July.
     For midday UK local time in summer, use 11:00:00Z instead.

     Current setting: Wed 29 July 2026, 12:00 UK local time (BST).

     Set to null to fall back to the data-close attribute on #vault-timer.
  --------------------------------------------------------------- */
  var ABA_VAULT_CLOSE = '2026-07-29T11:00:00Z';

  function start() {
    var el = document.getElementById('vault-timer');
    if (!el) return;
    var raw = ABA_VAULT_CLOSE || el.getAttribute('data-close');
    if (!raw) return;
    var target = new Date(String(raw).trim().replace(' ', 'T')).getTime();
    if (isNaN(target)) return;
    var d = el.querySelector('[data-d]');
    var h = el.querySelector('[data-h]');
    var m = el.querySelector('[data-m]');
    var s = el.querySelector('[data-s]');
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function set(a, b, c, e) {
      if (d) d.textContent = a;
      if (h) h.textContent = b;
      if (m) m.textContent = c;
      if (s) s.textContent = e;
    }
    var iv = null;
    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) {
        set('00', '00', '00', '00');
        if (iv) clearInterval(iv);
        el.style.display = 'none';
        var wrap = el.parentNode;
        if (wrap && !wrap.querySelector('.vault-timer__closed')) {
          var note = document.createElement('p');
          note.className = 'vault-timer__closed';
          note.textContent = 'This drop has closed';
          wrap.appendChild(note);
        }
        return;
      }
      var sec = Math.floor(diff / 1000);
      set(pad(Math.floor(sec / 86400)), pad(Math.floor((sec % 86400) / 3600)), pad(Math.floor((sec % 3600) / 60)), pad(sec % 60));
    }
    tick();
    iv = setInterval(tick, 1000);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();
